export enum TicketStatus {
    ASSIGNED_TO_ROLE_DIRECTOR = 'directorApproval',
    DIRECTOR_APPROVAL = 'directorApproval',
    IN_PROGRESS = 'inprogress',
    NEED_ASSIGNMENT = 'notAssigned',
    ASSIGNED_TO_ROLE_SECTION_MANAGER = 'smApproval',
    SM_APPROVAL = 'smApproval',
    ASSIGNED_TO_ROLE_GENERAL_MANAGER = 'gmApproval',
    GM_APPROVAL = 'gmApproval',
    CLOSED = 'closed',
    OPEN = 'open',
    DRAFT = 'draft',
    REJECTED = 'rejected',
    REJECT = 'reject',
    RETURNED = 'returned',
    NOT_ASSIGNED = 'notAssigned',
    Sent = 'sent',
    RETURN='return',
    REASSIGN='REASSIGN',
    CANCELLED='cancelled',
}
